<script setup lang="ts">
import { computed } from "vue";
import { UiChip } from "@shopexperts/shared";
import type { AiStepRunStatus } from "@shopexperts/legacy-api";
import { AI_STEP_RUN_STATUS_LABELS, aiStatusChipVariant, isAiRunActive } from "@/app/composables/expert-manager/aiSummaries";

const props = defineProps<{
  status: AiStepRunStatus;
  size?: "xs" | "sm";
}>();

const label = computed(() => AI_STEP_RUN_STATUS_LABELS[props.status]);
const variant = computed(() => aiStatusChipVariant(props.status));
const icon = computed(() => (isAiRunActive(props.status) ? "refresh-cw" : undefined));
</script>

<template>
  <UiChip
    :text="label"
    :variant="variant"
    :size="size ?? 'xs'"
    :icon="icon"
    rounded="full"
    :class="{ '[&_svg]:animate-spin': status === 'running' }"
  />
</template>
